import AbstractDataHandler from "../shared/AbstractDataHandler";
import { getBaseUrl, getPlanSlug } from "../shared/utils";

export default class DataHandler extends AbstractDataHandler {
    getData() {
        this.spinner.create(this.p.width / 2, this.p.height / 2, 200, this.backgroundColor, this.p.width, this.p.height);
        let uri = `${getBaseUrl(this.p)}/${getPlanSlug(this.p)}/data`;
        this.executeGetRequest(
            uri,
            data => this.loadData(data)
        );
    }
}
